<template>
      <app-left-right>
        <template #left>
          <app-product-category-tree
              ref="categoryTree"
              @select="selectCategory($event)"
          ></app-product-category-tree>
        </template>
        <template #right>
          <app-base-main parentTable :no-padding="true">
            <template #filter-group>
              <app-filter-group
                  @query="$gjNoticeQuery"
                  @reset="$gjReset">
                <gj-search-input
                    v-model="filter.name"
                    width="200px"
                    placeholder="请输入名称"
                ></gj-search-input>
                <gj-select
                    v-model="filter.status"
                    :options="ProductCategoryEnum.stateOption"
                    placeholder="状态"
                ></gj-select>
                <gj-creator-select
                    v-model="filter.createUserId"
                ></gj-creator-select>
                <gj-tooltip content="创建时间">
                  <gj-date-picker
                      v-model="filter.createDate"
                      type="daterange"
                  ></gj-date-picker>
                </gj-tooltip>
              </app-filter-group>
            </template>
            <template #operate-group>
              <gj-button v-if="$permission('category:add')" type="primary" @click="addCategory">添加</gj-button>
              <gj-button v-if="$permission('category:import')" @click="importCategory">导入</gj-button>
              <gj-button
                  v-if="$permission('category:delete')"
                  :disabled="noSelect || selectedSomeIs('isRelatedSku', true) || selectedSomeIs('isParent', true)"
                  @click="deleteCategory(selectedRows)">
                批量删除
              </gj-button>
              <template v-if="$permission('category:edit')">
                <gj-button
                    :disabled="!selectedAllIs('state', ProductCategoryEnum.status.ACTIVE)"
                    @click="inactiveCategory(selectedRows)">
                  批量停用
                </gj-button>
                <gj-button
                    :disabled="!selectedAllIs('state', ProductCategoryEnum.status.INACTIVE)"
                    @click="activeCategory(selectedRows)">
                  批量启用
                </gj-button>
              </template>
            </template>
            <template #tool-group>
              <gj-tool-group
                  log @viewLog="viewLog"
                  :download="$permission('category:export')" download-url="/supply/category/export" :download-params="globalParams"
                  help
              ></gj-tool-group>
            </template>
            <template #table>
              <gj-table
                  ref="gjTable"
                  adaptParent
                  name="productCategory"
                  :loading="loading"
                  :data="tableData"
                  :columns="columns"
                  :selection="$permission(['category:edit', 'category:delete'])"
                  sortable="custom"
                  :pagination="pagination"
                  @sort-change="$gjSortChange"
                  @page-change="$gjNoticeQuery">
                <template v-slot:parentName="{row}">
                  {{row.parentName | defaultShow}}
                </template>

                <template v-slot:state="{row}">
                  <gj-tag type="text" style="margin-right: 10px" shape="rectangle"
                          :color="row.state | optionColor(ProductCategoryEnum.stateOption)">
                    {{ row.state | optionText(ProductCategoryEnum.stateOption) }}
                  </gj-tag>
                </template>


                <template v-slot:op="{ row }">
                  <gj-button-group type="dropdown-op">
                    <template v-if="$permission('category:edit')">
                      <gj-button type="text" @click="editCategory(row)">编辑</gj-button>
                      <gj-button
                          v-if="row.state === ProductCategoryEnum.status.INACTIVE"
                          type="text"
                          @click="activeCategory([row])">
                        启用
                      </gj-button>
                      <gj-button
                          v-if="row.state === ProductCategoryEnum.status.ACTIVE"
                          type="text"
                          @click="inactiveCategory([row])">
                        停用
                      </gj-button>
                    </template>
                    <gj-tooltip
                        v-if="$permission('category:delete')"
                        :content="row.isRelatedSku ? '已关联产品，无法删除' : row.isParent ? '父级品类，无法删除' : null">
                      <gj-button
                          type="text"
                          :disabled="row.isRelatedSku || row.isParent"
                          @click="deleteCategory([row])">
                        删除
                      </gj-button>
                    </gj-tooltip>
                  </gj-button-group>
                </template>
              </gj-table>
            </template>
          </app-base-main>
        </template>
      </app-left-right>
</template>

<script>
  import AppProductCategoryAddModal from './modal/product-category-add-modal';
  import AppProductCategoryEditModal from './modal/product-category-edit-modal';
  import AppProductCategoryImportModal from './modal/product-category-import-modal';
  import AppProductCategoryTree from "./component/product-category-tree";
  import {ProductCategoryEnum} from "./enum";
  import {queryMixin, selectionMixin} from "../../../../minxins";
  import {defaultVal, isMeaningful} from "../../../../utils/common";
  import {convertToDate} from "../../../../utils/date.util";
  import {deleteProductCategory, disableOrEnableProductCategory, getProductCategoryPage} from "../../../../api/product";
  import {exportFile} from "../../../../api/common";
  import {PRODUCT_GET_PRODUCT_CATEGORY_TREE} from "../../../../store/action-types";

  export default {
    name: "app-product-category",
    mixins: [queryMixin, selectionMixin],
    components: {AppProductCategoryTree},
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'parentName', header: '上级名称', field: 'slot:parentName', minWidth: '100px'},
          {id: 'name', header: '品类名称', field: 'name', minWidth: '100px', overflowLine: 2, copyable: true},
          {id: 'memo', header: '描述', field: 'memo', minWidth: '200px', overflowLine: 2},
          {
            id: 'state',
            header: '状态',
            field: 'slot:state',
            options: ProductCategoryEnum.stateOption,
            minWidth: '60px'
          },
          {id: 'createUserName', header: '创建人', field: 'createUserName', minWidth: '100px'},
          {id: 'createTime', header: '创建时间', field: 'createTime', minWidth: '180px'},
          {id: 'op', header: '操作', field: 'slot:op', width: '150px', fixed: 'right', notCustomColumn: true},
        ],
        currentCategoryId: null,
        filter: {
          name: null,
          createDate: null,
          createUserId: null,
          status: ProductCategoryEnum.status.ACTIVE
        },
        ProductCategoryEnum: ProductCategoryEnum,
        globalParams: {},
        notStorage: true
      }
    },
    created() {
      this.sort.prop = 'pid,id';
      this.sort.order = 'ascending,descending';
    },
    methods: {
      selectCategory(categoryId) {
        this.currentCategoryId = categoryId;
        this.$gjNoticeQuery();
      },
      $gjQueryInitParams() {
        return {
          filter: {
            name: null,
            createDate: null,
            createUserId: null,
            status: ProductCategoryEnum.status.ACTIVE
          }
        };
      },
      $gjQuery() {
        // 构造查询参数
        const params = {
          model: {
            treeId: this.currentCategoryId,
            createUserId: defaultVal(this.filter.createUserId, null),
            name: this.filter.name,
            state: defaultVal(this.filter.status, null),
            startCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[0]) : null,
            endCreateTime: this.filter.createDate ? convertToDate(this.filter.createDate[1]) : null,
          },
          ...this.queryPagination,
          ...this.querySort
        };
        this.globalParams = params;
        // 查询
        this.loading = true;
        getProductCategoryPage(params)
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data.records;
              this.pagination = this.getPagination(data);
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
      download() {
        exportFile('/supply/category/export', this.globalParams);
      },
      viewLog() {
        this.$gjCreate('gj-log-modal', {
          props: {
            url: '/supply/category/logPage',
            opTypeOption: [
              {id: 'Enable', text: '启用'},
              {id: 'Disable', text: '停用'},
              {id: 'Add', text: '添加'},
              {id: 'Delete', text: '删除'},
              {id: 'Update', text: '更新'},
            ]
          }
        });
      },
      refreshStoreCategory() {
        this.$store.dispatch(PRODUCT_GET_PRODUCT_CATEGORY_TREE);
      },
      importCategory() {
        this.$gjCreate(AppProductCategoryImportModal, {
          on: {
            importFileSuccess: () => {
              this.$gjResetPage();
              this.$refs['categoryTree'].refresh();
              this.refreshStoreCategory();
            }
          }
        });
      },
      addCategory() {
        this.$gjCreate(AppProductCategoryAddModal, {
          props: {
            parentId: this.currentCategoryId
          },
          on: {
            created: () => {
              this.$gjMessage.success('添加成功');
              this.$gjResetPage();
              this.$refs['categoryTree'].refresh();
              this.refreshStoreCategory();
            }
          }
        });
      },
      editCategory(category) {
        const modal = this.$gjCreate(AppProductCategoryEditModal, {
          props: {
            category: category,
          },
          on: {
            updated: () => {
              this.$gjMessage.success('更新成功');
              this.$refs['categoryTree'].refresh();
              this.$gjResetPage();
              this.refreshStoreCategory();
            }
          },
        });
      },
      deleteCategory(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '删除确认',
            content: rows.length === 1
              ? `确定要删除[${rows[0].name}]吗？一旦删除不可恢复，请谨慎操作！`
              : `已选中 ${rows.length} 个品类，确定要批量删除吗？一旦删除不可恢复，请谨慎操作！`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              deleteProductCategory({
                ids: rows.map(e => e.id)
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$refs['categoryTree'].refresh();
                  this.$gjResetPage();
                  this.refreshStoreCategory();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      inactiveCategory(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '停用确认',
            content: rows.length === 1 ? `确定要停用[${rows[0].name}]吗？` : `已选中 ${rows.length} 个品类，确定要批量停用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              modal.confirmLoading = true;
              disableOrEnableProductCategory({
                ids: rows.map(e => e.id),
                state: ProductCategoryEnum.status.INACTIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$refs['categoryTree'].refresh();
                  this.$gjResetPage();
                  this.refreshStoreCategory();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      },
      activeCategory(rows) {
        const modal = this.$gjCreate("gj-info-modal", {
          props: {
            title: '启用确认',
            content: rows.length === 1 ? `确定要启用[${rows[0].name}]吗？` : `已选中 ${rows.length} 个品类，确定要批量启用吗？`,
          },
          on: {
            cancel: () => modal.$gjDestroy(),
            confirm: () => {
              disableOrEnableProductCategory({
                ids: rows.map(e => e.id),
                state: ProductCategoryEnum.status.ACTIVE
              })
                .then(() => {
                  this.$gjMessage.success('操作成功');
                  this.$refs['categoryTree'].refresh();
                  this.refreshStoreCategory();
                  this.$gjResetPage();
                  modal.$gjDestroy();
                })
                .complete(() => modal.confirmLoading = false);
            }
          },
        });
      }
    }
  }
</script>

<style scoped>

</style>
